export default __webpack_public_path__ + "static/media/extruder.e5b9ae5e.svg";